import { useState } from 'react';
import Raven from 'raven-js';
import { getAbsoluteReconnectUrl } from '../../utils/urlUtils';
import { BasicReconnectButton } from '../../components/reconnectButton/BasicReconnectButton';
import { postRefreshStatus } from './googleSheetsApi';
import { jsx as _jsx } from "react/jsx-runtime";
const FIVE_MINUTES = 300000;
export const GoogleSheetsReconnectButton = ({
  buttonProps,
  'data-test-id': dataTestId,
  label,
  metadata,
  onAuthStarted,
  onAuthCancelled,
  onAuthSucceeded,
  timeout = FIVE_MINUTES,
  url
}) => {
  const [loading, setLoading] = useState(false);
  const appId = metadata === null || metadata === void 0 ? void 0 : metadata.appId;
  const accountId = metadata === null || metadata === void 0 ? void 0 : metadata.accountId;
  const authUrl = getAbsoluteReconnectUrl({
    urlTemplate: url,
    appId,
    accountId
  });
  const handleAuthSucceeded = code => {
    setLoading(true);
    postRefreshStatus().catch(err => {
      Raven.captureException(err, {
        extra: {
          message: 'Error refreshing OAuth status for Google Sheets'
        }
      });
    }).finally(() => {
      onAuthSucceeded === null || onAuthSucceeded === void 0 || onAuthSucceeded(code);
      setLoading(false);
    });
  };
  const updatedButtonProps = Object.assign({}, buttonProps || {}, {
    disabled: buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.disabled,
    failed: buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.failed,
    loading: (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.loading) || loading
  });
  return authUrl && label ? /*#__PURE__*/_jsx(BasicReconnectButton, {
    buttonProps: updatedButtonProps,
    "data-test-id": dataTestId,
    label: label,
    onAuthStarted: onAuthStarted,
    onAuthCancelled: onAuthCancelled,
    onAuthSucceeded: handleAuthSucceeded,
    timeout: timeout,
    url: authUrl
  }) : null;
};